import { useMutation } from "@apollo/client";
import { createAjv } from "@jsonforms/core";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Button } from "pepsico-ds";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { createSegment } from "../../../graphql/mutations/createSegment";
import JsonFormsWrapper from "../../jsonForms/jsonFormsWrapper/JsonFormsWrapper";
import {
  createPlatformSegmentJsonSchema,
  createPlatformSegmentUISchema,
} from "./utils/schemas";

function CreatePlatformSegmentModal({
  showModal,
  onClose,
  showToast,
  selected = {},
  segmentListRef,
}) {
  const programId = localStorage.getItem("programId") || "";
  const [createSegmentCall] = useMutation(createSegment);

  const [formData, setFormData] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const ajv = createAjv();

  useEffect(() => {
    if (showModal) {
      setFormData({});
    }
  }, [showModal]);

  const handleClose = () => {
    onClose?.();
  };

  const validateForm = (payload) => {
    const validator = ajv.compile(createPlatformSegmentJsonSchema);
    const isValid = validator(payload);
    return isValid;
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const payload = {
        id: selected?.id || uuidv4(),
        name: formData?.name,
        type: "PLATFORM",
        programId,
        population: selected?.population || 0,
        status: formData?.status,
        attributes: [],
        attributeValues: [],
        rules: "",
      };
      if (!validateForm(payload)) {
        showToast?.("error", "Please fill all the required fields", "");
        return;
      }
      const { data } = await createSegmentCall({
        variables: { input: payload },
      });
      if (data?.createSegment) {
        showToast?.("success", "Platform Segment created successfully", "");
        segmentListRef?.current?.refetch();
        onClose?.();
      } else {
        showToast?.("error", "Platform Segment created failed", "");
      }
    } catch (error) {
      showToast?.("error", "Platform Segment created failed", error?.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      className="create-platform-segment-modal"
      open={showModal}
      scroll="paper"
    >
      <DialogTitle>
        <Grid container justifyContent="space-between" direction="row">
          <Grid item xs={10}>
            <h2>Create Platform Segment</h2>
          </Grid>
          <Grid item xs={1} display="flex" justifyContent="flex-end">
            <CloseIcon onClick={handleClose} className="cursor-pointer" />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ overflowX: "hidden" }}>
        <div className="my-5">
          <JsonFormsWrapper
            jsonschema={createPlatformSegmentJsonSchema}
            uischema={createPlatformSegmentUISchema}
            data={formData}
            onChange={(e) => {
              setFormData(e);
            }}
          />
        </div>
        <div className="mt-5 display-flex justify-content-end align-items-center">
          <Button
            onClick={handleClose}
            variant="tertiary"
            className="mr-3"
            size="medium"
          >
            Cancel
          </Button>
          <Button
            variant="secondary"
            onClick={handleSubmit}
            disabled={submitting}
            iconTrailing="arrow_forward"
            size="medium"
            isLoading={submitting}
          >
            Create
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CreatePlatformSegmentModal;
